import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col gap-12px" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "cursor-action" }
const _hoisted_4 = {
  key: 2,
  class: "row mtop-10"
}
const _hoisted_5 = { class: "cursor-action" }
const _hoisted_6 = { class: "row mtop-10" }
const _hoisted_7 = {
  key: 0,
  class: "row-top flexwrap gap-10"
}
const _hoisted_8 = { class: "row mtop-10" }
const _hoisted_9 = {
  key: 4,
  class: "row",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_10 = { class: "bg-modal w-maxC" }

import accidentInput from '@/views/patientMain/dashbAdmin/cns/accidentInput.vue'
import cnsIdInput from '@/views/patientMain/dashbAdmin/cns/cnsIdInput.vue'
import cnsModify from "./cnsModify.vue"
import cnsEditAffiliationNumber from "./cnsEditAffiliationNumber.vue"
import cmcmModify from "./cmcmModify.vue"
import mrInput from "./mrInput.vue"
import EsDataCard from '@/components/esDataCard.vue';
import DropdownBox from '@/containers/dropdownBox.vue';

import { computed, ref } from 'vue'
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useI18n } from "vue-i18n";
import { formatMatricule } from '@/functions/lu.js';
import { apiDateString } from '@/api/apicommon';
import { toastSuccess } from '@/utils/toast-utils';
import { Button, useToast } from "primevue";
import { useUiStore } from '@/stores/ui';
import { useAppUserStore } from '@/stores/appUser'
import patientapi from '@/api/patientapi';
import relationshipapi from "@/api/relationshipapi";


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbCns',
  emits: ["modal-close"],
  setup(__props, { emit: __emit }) {

const toast = useToast();
const appUserStore = useAppUserStore()
const uiStore = useUiStore();
const currentEntryStore = useCurrentEntryStore();
const { t } = useI18n();

const emits = __emit;

const dropd = ref("");
const isAddCnsNumberModalOpen = ref<boolean>(false);
const isUpdateCnsNumberModalOpen = ref<boolean>(false);

const pwrPatient = computed(() => {
  return currentEntryStore.modalPatient;
})

async function cnsToClipboard(pwrPatient: any) {
  const matricule = pwrPatient.cnsHealthInsurance?.cnsAffiliationNumber ? formatMatricule(pwrPatient.cnsHealthInsurance.cnsAffiliationNumber) : "";
  const text = matricule + " " + pwrPatient.lastName.toUpperCase() + " " + pwrPatient.firstName;
  try {
    await navigator.clipboard.writeText(text);
    toastSuccess(toast, {
      summary: t('patient.admin.cnsNumber.copied'),
      detail:  text
    });
  } catch (err) {
    console.error('Failed to copy text: ', err);
  }
}

function openMedRefDocuments() {
  dropd.value = "openMedRefDocuments";
}

function openEditCnsNumberFct() {
  isUpdateCnsNumberModalOpen.value = true;
}

function onUpdateCnsModalClose() {
  dropd.value = '';
  isUpdateCnsNumberModalOpen.value = false;
}

async function afterUpdateFct() {
  await currentEntryStore.reloadPatientOnly();
  onUpdateCnsModalClose();
}

async function createMrRpa() {
  await addLuCnsReferenceDrToPwr();
  createTemplate("RésuméPatientAdulte", "RPA")
}

async function createMrDeclaration() {
  await addLuCnsReferenceDrToPwr();
  createTemplate("MrDeclaration", "Déclaration MR")
}

async function addLuCnsReferenceDrToPwr() {
  if (pwrPatient.value.cnsReferenceDr) return;
  const pwrPatientId = pwrPatient.value.personWithRoleId;
  const pwrHealthPro = appUserStore.currentHealthGroupMembership.pwr;
  const referenceDrMain = `${pwrHealthPro.title} ${pwrHealthPro.lastName} ${pwrHealthPro.firstName}`;
  const declarationDate = currentEntryStore.currentEntryDate;
  await relationshipapi.addLuCnsReferenceDrToPwr(pwrPatientId, referenceDrMain, "", "", declarationDate);
  await currentEntryStore.reloadPatientOnly();
}

async function createTemplate(internalCode: string, originalText: string) {
  emits("modal-close");
  uiStore.clearDashBoard();
  currentEntryStore.setMiddleTab('docTemplate');
  currentEntryStore.clearCurrExpr_Ccl();
  currentEntryStore.emptyCurrentDoc();
  const newDoc = await patientapi.addOfficialTemplateToCclZero(internalCode, originalText, "", "None", currentEntryStore.currentEntryId);
  currentEntryStore.setCurrentDoc(newDoc);
  currentEntryStore.reloadCurrentEntry();
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.admin.ssl'),
        class: "h4"
      }, null, 8, ["txt"])
    ]),
    (pwrPatient.value.cnsHealthInsurance?.cnsAffiliationNumber)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(DropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dropd).value = $event)),
            openOn: "cnsModify"
          }, {
            dropd: _withCtx(() => [
              _createVNode(cnsModify, {
                cns: pwrPatient.value.cnsHealthInsurance,
                onOpenEditCnsNumber: _cache[1] || (_cache[1] = ($event: any) => (openEditCnsNumberFct()))
              }, null, 8, ["cns"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(EsDataCard, {
                  title: _unref(t)('patient.admin.cnsNumber.title'),
                  icon: 'hashtag',
                  folderIcon: 'shareIcons',
                  backgroundClass: "bg-blue-04",
                  onIconClick: _cache[0] || (_cache[0] = ($event: any) => (cnsToClipboard(pwrPatient.value)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(formatMatricule)(pwrPatient.value.cnsHealthInsurance.cnsAffiliationNumber),
                      class: "pleft-30px txt-grey-64"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }, 8, ["title"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(cnsEditAffiliationNumber, {
            "is-open": isUpdateCnsNumberModalOpen.value,
            cns: pwrPatient.value.cnsHealthInsurance,
            onClose: onUpdateCnsModalClose,
            onAfterUpdate: _cache[3] || (_cache[3] = ($event: any) => (afterUpdateFct()))
          }, null, 8, ["is-open", "cns"])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_unref(Button), {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (isAddCnsNumberModalOpen.value = true)),
            variant: "text",
            class: "modal-btn"
          }, {
            default: _withCtx(() => [
              _createVNode(EsDataCard, {
                title: _unref(t)('patient.admin.cnsNumber.title'),
                icon: 'hashtag',
                folderIcon: 'shareIcons',
                backgroundClass: "bg-blue-04"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.admin.cnsNumber.add'),
                    class: "pleft-30px txt-grey-64"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _: 1
          }),
          _createVNode(cnsIdInput, {
            cns: pwrPatient.value.cnsHealthInsurance,
            "is-open": isAddCnsNumberModalOpen.value,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (isAddCnsNumberModalOpen.value = false))
          }, null, 8, ["cns", "is-open"])
        ], 64)),
    (pwrPatient.value.cnsHealthInsurance)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(DropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dropd).value = $event)),
            openOn: "cmcmModify"
          }, {
            dropd: _withCtx(() => [
              _createVNode(cmcmModify, {
                cmcm: pwrPatient.value.cmcmHealthInsurance
              }, null, 8, ["cmcm"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(EsDataCard, {
                  title: _unref(t)('patient.admin.cmcm.title'),
                  icon: 'hashtag',
                  folderIcon: 'shareIcons',
                  backgroundClass: "bg-blue-04"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: pwrPatient.value.cmcmHealthInsurance.isCmcmActive? _unref(t)('common.yes') : _unref(t)('common.no'),
                      class: "pleft-30px txt-grey-64"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }, 8, ["title"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (pwrPatient.value.cnsHealthInsurance)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.admin.subsubtitle.workAccident'),
              class: "h5"
            }, null, 8, ["txt"]),
            _createVNode(DropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dropd).value = $event)),
              openOn: "addLuCnsWorkAccident"
            }, {
              dropd: _withCtx(() => [
                _createVNode(accidentInput, {
                  cns: pwrPatient.value.cnsHealthInsurance,
                  onClose: _cache[7] || (_cache[7] = ($event: any) => (dropd.value = ''))
                }, null, 8, ["cns"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "plus",
                      styles: "main-m"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (pwrPatient.value.cnsHealthInsurance.cnsWorkAccidents)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pwrPatient.value.cnsHealthInsurance.cnsWorkAccidents, (accident, indexAccident) => {
                  return (_openBlock(), _createBlock(DropdownBox, {
                    key: indexAccident,
                    modelValue: dropd.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dropd).value = $event)),
                    openOn: 'input-accident-' + indexAccident,
                    class: "cursor-action"
                  }, {
                    dropd: _withCtx(() => [
                      _createVNode(accidentInput, {
                        ref_for: true,
                        ref: 'input-accident-' + indexAccident,
                        accident: accident,
                        onClose: _cache[9] || (_cache[9] = ($event: any) => (dropd.value = ''))
                      }, null, 8, ["accident"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(EsDataCard, {
                        title: accident.accidentNumber + ' du ' + _unref(apiDateString)(accident.accidentDate),
                        icon: 'hashtag',
                        folderIcon: 'shareIcons',
                        ref_for: true,
                        ref: 'work-accident-' + indexAccident,
                        backgroundClass: "bg-blue-04"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: accident.accidentDescription,
                            class: "pleft-30px txt-grey-64"
                          }, null, 8, ["txt"])
                        ]),
                        _: 2
                      }, 1032, ["title"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "openOn"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.admin.referringDoctor.title'),
        class: "h5"
      }, null, 8, ["txt"]),
      (!pwrPatient.value.cnsReferenceDr)
        ? (_openBlock(), _createBlock(DropdownBox, {
            key: 0,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dropd).value = $event)),
            openOn: "addReferringDoctor"
          }, {
            dropd: _withCtx(() => [
              _createVNode(mrInput, {
                pwrPatient: pwrPatient.value,
                onClose: _cache[11] || (_cache[11] = ($event: any) => (dropd.value = ''))
              }, null, 8, ["pwrPatient"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "plus",
                    styles: "main-m"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (!pwrPatient.value.cnsReferenceDr)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 1,
            class: "align-center mleft-20",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (createMrDeclaration()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "fileText",
                styles: "size-s",
                style: {"margin-top":"-0.5rem"},
                class: "img-primary"
              }),
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.admin.referringDoctor.createMrDeclaration'),
                class: "mleft-05 txt-primary font-size-14"
              }, null, 8, ["txt"])
            ]),
            _: 1
          }))
        : (pwrPatient.value.cnsReferenceDr.cnsReferenceDrNumber)
          ? (_openBlock(), _createBlock(_component_buttonGroup, {
              key: 2,
              class: "align-center mleft-20",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (createMrRpa()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "fileText",
                  styles: "size-s",
                  style: {"margin-top":"-0.5rem"},
                  class: "img-primary"
                }),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('patient.admin.referringDoctor.createMrRpa'),
                  class: "mleft-05 txt-primary font-size-14"
                }, null, 8, ["txt"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ]),
    (pwrPatient.value.cnsReferenceDr)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(DropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dropd).value = $event)),
            openOn: "openMedRefDocuments",
            class: "cursor-action"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_dbGroup, { style: {"width":"10rem"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_list_group, { class: "pad-s" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_item, {
                          style: {"margin-top":"-0.1rem"},
                          icon: "file",
                          styles: "main-m"
                        }),
                        _createVNode(_component_text_item, {
                          class: "mleft-04",
                          txt: "Déclaration initiale"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_list_group, { class: "pad-s" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_item, {
                          style: {"margin-top":"-0.1rem"},
                          icon: "file",
                          styles: "main-m"
                        }),
                        _createVNode(_component_text_item, {
                          class: "mleft-04",
                          txt: "RPA"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(DropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((dropd).value = $event)),
            openOn: "cnsReferenceDr",
            class: "cursor-action"
          }, {
            dropd: _withCtx(() => [
              _createVNode(mrInput, {
                cnsReferenceDr: pwrPatient.value.cnsReferenceDr,
                onClose: _cache[17] || (_cache[17] = ($event: any) => (dropd.value = ''))
              }, null, 8, ["cnsReferenceDr"])
            ]),
            default: _withCtx(() => [
              _createVNode(EsDataCard, {
                title: pwrPatient.value.cnsReferenceDr.referenceDrMain ? pwrPatient.value.cnsReferenceDr.referenceDrMain : _unref(t)('patient.admin.referringDoctor.title'),
                icon: 'stethoscope',
                folderIcon: 'shareIcons',
                ref: "cnsReferenceDr",
                backgroundClass: "bg-blue-04",
                onIconClick: _cache[16] || (_cache[16] = ($event: any) => (openMedRefDocuments()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_text_item, {
                      txt: 'MR remplaçant: ' + pwrPatient.value.cnsReferenceDr.referenceDrReplacement,
                      class: "pleft-30px txt-grey-64"
                    }, null, 8, ["txt"]),
                    (pwrPatient.value.cnsReferenceDr.declarationDate)
                      ? (_openBlock(), _createBlock(_component_text_item, {
                          key: 0,
                          txt: 'Date déclaration: ' + _unref(apiDateString)(pwrPatient.value.cnsReferenceDr.declarationDate),
                          class: "pleft-30px txt-grey-64"
                        }, null, 8, ["txt"]))
                      : _createCommentVNode("", true),
                    (pwrPatient.value.cnsReferenceDr.cnsReferenceDrNumber)
                      ? (_openBlock(), _createBlock(_component_text_item, {
                          key: 1,
                          txt: 'Numéro déclaration: ' + pwrPatient.value.cnsReferenceDr.cnsReferenceDrNumber,
                          class: "pleft-30px txt-grey-64"
                        }, null, 8, ["txt"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})